export default {
  setFieldTitles(state, titles) {
    state.titles = titles;
  },

  setFieldValues(state, values) {
    state.values = values;
  }
};
